<template>
  <b-row v-if="listingStats && transactionStats">
    <b-col>
      <stats-card title="Days Left:"
                  type="gradient-danger"
                  :sub-title="listingStats.days_left.toString()"
                  icon="fas fa-calendar">

        <template slot="footer">
          <span class="text-nowrap">to take listings in Q{{ listingStats.quarter }} ({{ listingStats.year }}) - <strong>{{ new Date(listingStats.end_date) | date('M/d/Y') }}</strong></span>
        </template>
      </stats-card>
    </b-col>
    <b-col>
      <stats-card title="Days Left:"
                  type="gradient-info"
                  :sub-title="transactionStats.days_left.toString()"
                  icon="fas fa-calendar">

        <template slot="footer">
          <span class="text-nowrap">to sell in Q{{ transactionStats.quarter }} ({{ new Date(transactionStats.end_date) | date('Y') }}) - <strong>{{ new Date(transactionStats.end_date) | date('M/d/Y') }}</strong></span>
        </template>
      </stats-card>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    listingStats: null,
    transactionStats: null,
    year: null,
    transactionYear: null
  },
};
</script>